import { render, staticRenderFns } from "./jdGiftOrderConfirm.vue?vue&type=template&id=3652de54&scoped=true&"
import script from "./jdGiftOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./jdGiftOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./jdGiftOrderConfirm.vue?vue&type=style&index=0&id=3652de54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3652de54",
  null
  
)

export default component.exports